import Text from 'components/Text/Text';
import { ILocalizationContext, LocalizationContext } from '../../../../../localizationState/localizationContext';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<ILocalizationContext>(LocalizationContext);

	const containerClasses = classNames(style.container, { [style.visible]: true });

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
